module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Dual Camera Module with Depth of Field Calculation.5feb1882.png";